/**
 * PreparationKind - synchronized with the Prisma enum of the same name.
 * Feeds `resolveDefrostState`: COOKED with frozen rows proposes
 * FROZEN_INGREDIENTS_ONLY, ASSEMBLED_RAW with thawed rows proposes
 * SOLD_DEFROSTED, SOLD_AS_IS proposes SOLD_DEFROSTED without a question.
 */
export const PREPARATION_KINDS = ['COOKED', 'ASSEMBLED_RAW', 'SOLD_AS_IS'] as const;
export type PreparationKind = (typeof PREPARATION_KINDS)[number];
